import axios from "axios";
axios.defaults.headers.common['Authorization'] = localStorage.getItem('auth_token') ;

const ServicioReportes = {};
const { REACT_APP_API_URL_REPORTES } = process.env;
const REPORTES_BASE = (REACT_APP_API_URL_REPORTES || 'http://localhost:4005').replace(/\/$/, '');

//? Listar Reportes.
ServicioReportes.getReportesAxios = async () => {
  return await axios({
    method: "get",
    url: `${REPORTES_BASE}/api/reportes/list`,
    responseType: "json",
  }).then(response => response.data)
    .catch(err => err);
};


//? Listar Un Reportes.
ServicioReportes.getOneReporteAxios = async (data) => {
  const { id } = data
  return await axios({
    method: "get",
    url: `${REPORTES_BASE}/api/reporte/listone`,
    params: { _id: id},
    responseType: "json",
  })
    .then((response) => response.data)
    .catch((err) => err);
};


//? Agregar Reportes.
ServicioReportes.addReportesAxios = async (data) => {
  return await axios({
    method: "post",
    url: `${REPORTES_BASE}/api/reportes/create`,
    // url: `http://localhost:4003/api/reportes/create`,
    data: { ...data },
  })
    .then((response) => response.data)
    .catch((err) => err);
};

//? Eliminar Reportes.
ServicioReportes.deleteReportesAxios = async (data) => {
  return await axios({
    method: "delete",
    url: `${REPORTES_BASE}/api/reportes/delete`,
    // url: `http://localhost:4003/api/reportes/delete`,
    params: {_id:data},
  }).then((response) => response.data);
};

//? Eliminar una unidad de negocio completa.
ServicioReportes.deleteUnidadNegocioAxios = async (unidadNegocio) => {
  return await axios({
    method: "delete",
    url: `${REPORTES_BASE}/api/reportes/delete-by-unit`,
    params: { unidadNegocio },
  })
    .then((response) => response.data)
    .catch((err) => err.response?.data || { msg: err.message });
};

//? Actualizar Reportes.
ServicioReportes.updateReportesAxios = async (data) => {

  return await axios({
    method: "post",
    url: `${REPORTES_BASE}/api/reportes/edit`,
    // url: `http://localhost:4003/api/reportes/edit`,
    data: { ...data },
  })
    .then((response) => response.data)
    .catch((err) => err);
};

//? Obtener configuracion de embed para Power BI (RLS / Embed Token)
ServicioReportes.getPowerBiEmbedConfigAxios = async (data) => {
  return await axios({
    method: "post",
    url: `${REPORTES_BASE}/api/reportes/embed-config`,
    data: { ...data },
    responseType: "json",
  })
    .then((response) => response.data)
    .catch((err) => err.response?.data || { error: true, msg: err.message });
};

export default ServicioReportes;
